import { ChainID } from '@ankr.com/chains-list';
import { capitalize } from '@mui/material';

export const renderTacName = (chainId: ChainID) => {
  const name = capitalize(chainId);

  const namesMap: Partial<Record<ChainID, string>> = {
    [ChainID.TAC]: 'TAC',
    [ChainID.TAC_EVM]: 'EVM JSON-RPC',
    [ChainID.TAC_TENDERMINT_JSON_RPC]: 'Tendermint JSON-RPC',
    [ChainID.TAC_TENDERMINT_REST]: 'Tendermint REST',
    [ChainID.TAC_COSMOS_REST]: 'Cosmos REST',
    [ChainID.TAC_COSMOS_GRPC]: 'Cosmos gRPC-web',
    [ChainID.TAC_TESTNET_TURIN]: 'Turin',
    [ChainID.TAC_TESTNET_TURIN_COSMOS_GRPC]: 'Cosmos gRPC',
    [ChainID.TAC_TESTNET_TURIN_COSMOS_REST]: 'Cosmos REST',
    [ChainID.TAC_TESTNET_TURIN_EVM]: 'EVM JSON-RPC',
    [ChainID.TAC_TESTNET_TURIN_TENDERMINT_REST]: 'Tendermint REST',
    [ChainID.TAC_TESTNET_TURIN_TENDERMINT_RPC]: 'Tendermint JSON-RPC',
    [ChainID.TAC_TESTNET_SPB]: 'SPB',
    [ChainID.TAC_TESTNET_SPB_COSMOS_GRPC]: 'Cosmos gRPC',
    [ChainID.TAC_TESTNET_SPB_COSMOS_REST]: 'Cosmos REST',
    [ChainID.TAC_TESTNET_SPB_EVM]: 'EVM JSON-RPC',
    [ChainID.TAC_TESTNET_SPB_TENDERMINT_REST]: 'Tendermint REST',
    [ChainID.TAC_TESTNET_SPB_TENDERMINT_RPC]: 'Tendermint JSON-RPC',
  };

  return namesMap[chainId] || name;
};
